import type { SVGProps } from 'react';
export const SvgEyeOff = (props: SVGProps<SVGSVGElement>) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width={20}
		height={20}
		fill="none"
		viewBox="0 0 20 20"
		{...props}
	>
		<path
			stroke="#AAA"
			strokeLinecap="round"
			strokeLinejoin="round"
			strokeWidth={2}
			d="m2.5 2.5 2.99 2.991M17.5 17.5l-2.99-2.99m-2.948 1.177A8.337 8.337 0 0 1 2.048 10c.29-.92.734-1.772 1.303-2.524m4.881.756a2.5 2.5 0 0 1 3.536 3.536M8.232 8.232l3.536 3.536M8.232 8.232 5.491 5.491m6.277 6.277L5.49 5.49m6.277 6.277 2.741 2.741M5.491 5.491A8.337 8.337 0 0 1 17.952 10a8.35 8.35 0 0 1-3.443 4.51"
		/>
	</svg>
);
